<template>
    <div class="h-100">
        <YandexMetrika :counter-id="+yandexMetrikaId"  v-if="yandexMetrikaId" />
        <transition name="fade">
            <div class="maintenance-mode-wrapper" v-if="$store.getters.getMaintenanceMode">
                <div class="w-75">
                    <p>Сервис обновляется... Работа по обновлению, как правило, занимает до 15 минут.</p>
                    <p>The service is being updated ... Updating usually takes up to 15 minutes.</p>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <router-view v-if="language" />
        </transition>
        <!--        <IframeModal iframe-src="/webapp/organizer/applications/1331" v-if="$store.getters.getIframeApplication.visible"></IframeModal>-->
        <div class="scroll-btn">
            <i class="flaticon-up-arrow"></i>
        </div>
    </div>
</template>

<script>

import IframeModal from './js/components/customComponents/IframeModal.vue'
import YandexMetrika from './js/components/wrappers/YandexMetrika.vue'
// import Snowflakes from 'magic-snowflakes';

export default {
    name: 'App',
    components: { IframeModal, YandexMetrika },
    data() {
        return {
            yandexMetrikaId: null,
            organizerSlug: null,
            snowflakes: null
        }
    },
    created() {
        let self = this

        // window.env === 'production' && this.startPing();
        this.startPing()

        let params = getUrlParams()

        this.initAxiosResponseSettings()
        this.initAxiosRequestSettings()
        this.initFunctionsWrappers()

        if (
            this.$route.name === 'auth'
            || this.$route.path.indexOf('/public/') !== -1
            || this.$route.path.indexOf('/StageManager/') !== -1
        ) {
            this.getLanguage(params.lang !== undefined ? params.lang : 'ru')
        } else {
            this.getLanguage()
        }

        $(document).on('click', '[data-go-to]', (e) => {
            Swal.close()
            this.$router.push({ name: e.target.dataset.goTo })
        })
    },
    computed: {
        language() {
            return this.$store.getters.getLanguage
        },
        locale() {
            return this.$store.getters.getLocale
        },
        initStatus() {
            return this.$store.getters.getInitStatus
        },
        currentUser() {
            return this.$store.getters.getCurrentUser
        },
        baseDomain() {
            const parts = location.hostname.split('.')

            if (parts.length >= 2) {
                return parts.slice(-2).join('.')
            }

            return location.hostname
        }
    },
    beforeMount() {
        const faviconLink = document.getElementById('favicon')

        if (this.baseDomain === 'alyans-talantov.ru') {
            faviconLink.href = 'https://static.tildacdn.com/tild3865-6166-4237-b431-333265643164/favicon.ico'
        } else if (this.baseDomain === 'artnavigator.pro') {
            faviconLink.href = 'https://organizer.xn--80aaahf3a6anlhog.xn--p1ai/favicon.ico'
        } else {
            const i = setInterval(() => {
                if(this.currentUser && this.currentUser.role === 'organizer') {
                    const script = document.createElement('script')
                    script.src = '//code.jivo.ru/widget/Qpz4wJAnaM'
                    script.async = true

                    document.body.appendChild(script)
                    clearInterval(i)
                }
            }, 1000)
        }
    },
    mounted() {
        this.loadSiteData();
        $(document).on('click', '[data-demo]', e => {
            e.preventDefault()
            this.demo(e.target.dataset.demo)
        })

        // Катающееся оглавление статьи
        $(document).scroll(function() {
            const windowHeight = $(window).height()
            const scrollTop = $(window).scrollTop()
            const opacity = (scrollTop - 200) / windowHeight

            $('.scroll-btn').css('opacity', opacity <= 1 ? opacity : 1)
        })

        // Кнопка поднятия вверх страницы
        $(document).on('click', '.scroll-btn', function(e) {
            e.preventDefault()
            $('body, html').animate({ scrollTop: 0 }, 800)
        })

        // this.snowflakes = new Snowflakes({
        //     count: 30
        // });

    },
    beforeDestroy() {
        this.snowflakes.destroy();
    },
    methods: {
        loadSiteData(){
            axios.get(window.apiUrl + '/api/sites/getSiteData').then(r => {
                const site = r.data.data.site;

                if(site && site.ym) {
                    this.yandexMetrikaId = site.ym
                }

            })
        },
        demo(key) {

            switch (key) {
                case 'btn.money':
                    swalMoneyBtn(() => {

                    })
                    break
                default:
                    swalPremiumBtn(() => {

                    })
            }
        },
        startPing() {
            let self = this

            axios.get(window.apiUrl + '/api/ping').then(function(response) {
                if (self.$store.getters.getMaintenanceMode) { // Если было залочено, то перезагружаем страницу
                    location.reload()
                }
            }).catch(function(error) {

            }).finally(function() {
                setTimeout(function() {
                    self.startPing()
                }, 60000)
            })
        },
        getLanguage(lang) {
            let self = this

            let langQuery = lang ? '?lang=' + lang : ''

            axios.get(window.apiUrl + '/api/init/getLanguage' + langQuery).then(function(response) {
                self.$store.commit('setLocale', response.data.locale)
                self.$store.commit('setLanguage', response.data.translationForUI)

                window.currentLang = lang
            })
        },
        initFunctionsWrappers() {
            let self = this

            window.swalAreYoySure = function(callback, text = '', title = '', errorCallback = null) {
                return Swal.fire({
                    title: title ? title : self.language.areYouSure + '?',
                    text: text,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: self.language.yes,
                    cancelButtonText: self.language.cancel,
                    reverseButtons: true
                }).then(function(result) {
                    if (result.value) {
                        callback(result)
                    } else if (errorCallback) {
                        errorCallback(result)
                    }
                })
            }

            window.swalPremiumBtn = function(callback, text = '') {
                return Swal.fire({
                    title: 'Снимите ограничения!',
                    html: `
                            <div class="mb-3">${text}</div>
                            <div>Вы можете снять ограничения для текущего мероприятия!</div>
                            <div>
                                <button data-go-to="organizerFestivalPremium" class="btn btn-success">Снять ограничения</button>
                            </div>
                        `,
                    icon: 'info',
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(function(result) {
                    if (result.value) {
                        callback(result)
                    }
                })
            }
            window.swalMoneyBtn = function(callback, text = '') {
                return Swal.fire({
                    title: 'Снимите ограничения!',
                    html: `
                            <div>Модуль "Учет денег" можно купить в разделе "Аккаунт"</div>
                            <div>
                                <button data-go-to="organizerFinances" class="btn btn-success">Перейти в раздел "Аккаунт"</button>
                            </div>
                        `,
                    icon: 'info',
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(function(result) {
                    if (result.value) {
                        callback(result)
                    }
                })
            }
            window.swalMessageWithButton = function(callback, text = '', title = '') {
                return Swal.fire({
                    title: title ? title : '',
                    html: `<div>${text}</div>`,
                    icon: 'info',
                    showCancelButton: false,
                    showConfirmButton: true,
                    allowOutsideClick: false,   // запрет на клик вне окна
                    allowEscapeKey: false,      // запрет на закрытие по Esc
                    allowEnterKey: false       // запрет на закрытие по Enter
                    // confirmButtonText: self.language.ok,
                }).then(function(result) {
                    if (result.value) {
                        callback(result)
                    }
                })
            }
            window.swalFireSuccess = function(msg) {
                $.notify({
                    message: msg ? msg : self.language.success
                    // type: 'success'
                }, {
                    // settings
                    element: 'body',
                    position: null,
                    type: 'success',
                    allow_dismiss: true,
                    newest_on_top: false,
                    showProgressbar: false,
                    placement: {
                        from: 'top',
                        align: 'right'
                    },
                    offset: 20,
                    spacing: 10,
                    z_index: 1031,
                    delay: 1000,
                    timer: 2000,
                    url_target: '_blank',
                    mouse_over: null,
                    animate: {
                        enter: 'animate__animated animate__pulse',
                        exit: 'animate__animated animate__fadeOutUp'
                    },
                    onShow: null,
                    onShown: null,
                    onClose: null,
                    onClosed: null,
                    icon_type: 'class'
                })


                /*                Swal.fire({
                                    position: "top-right",
                                    icon: "success",
                                    title: self.language.success,
                                    showConfirmButton: false,
                                    timer: 1000,
                                    allowOutsideClick: false,
                                    closeOnClickOutside: false

                                });*/
            }
            window.swalFireError = function(message) {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: self.language.error,
                    html: message,
                    showConfirmButton: true,
                    confirmButtonText: 'OK'
                    // timer: 1000
                })
            }
            window.swalNewNotifications = function() {
                Swal.fire({
                    // position: "top-right",
                    icon: 'info',
                    title: 'У вас есть непрочитанные уведомления!',
                    html: 'Для того, чтобы их прочитать нажмите на колольчик в правом верхнем углу экрана!',
                    showConfirmButton: true,
                    // timer: 1000,
                    allowOutsideClick: false,
                    closeOnClickOutside: false
                })


            }
        },
        initAxiosRequestSettings() {
            let self = this

            axios.interceptors.request.use(function(config) {
                if (localStorage.getItem('authToken')) {
                    config.headers.Authorization = 'Bearer ' + localStorage.getItem('authToken')

                    // Только если домен не задан вручную
                    if (!config.headers.domain) {
                        config.headers.domain = window.location.host
                    }

                }
                // Do something before request is sent
                return config
            }, function(error) {
                // Do something with request error
                return Promise.reject(error)
            })
        },
        initAxiosResponseSettings() {
            let self = this

            axios.interceptors.response.use(function(response) {
                return response
            }, function(error) {
                if (error.response) {
                    switch (error.response.status) {
                        case 401:
                            localStorage.removeItem('authToken')
                            if (self.$route.name === 'organizerAuth' || self.$route.name === 'userAuth' || self.$route.name === 'auth') { // todo убрать старые роуты
                                swalFireError(self.language.wrongEmailOrPassword)
                            } else {
                                if (error.response.data.redirect) {
                                    location.href = error.response.data.redirect
                                } else {
                                    location.href = '/'
                                }
                            }
                            break
                        case 403:
                            swalFireError(self.language.uVasNetPravNaVypolnenieDannogoDeistviya)
                            break
                        case 422:
                            let html = ''

                            if (error.response.data.errors) {
                                html = '<ul class="errors-items" style="list-style: none; margin: 0; padding: 0;">'
                                for (let key in error.response.data.errors) {
                                    error.response.data.errors[key].forEach(function(errorText) {
                                        html += '<li>- ' + errorText + '</li>'
                                    })
                                }
                                html += '</ul>'
                            } else {
                                html = error.response.data.message
                            }

                            Swal.fire({
                                width: window.innerWidth > 768 ? 600 : 400,
                                title: self.language.anErrorHasOccurred,
                                html: html,
                                icon: 'error',
                                buttonsStyling: false,
                                confirmButtonText: self.language.clear,
                                customClass: {
                                    confirmButton: 'btn btn-primary'
                                }
                            })
                            break
                        case 500:
                            Swal.fire(self.language.anErrorHasOccurred, self.language.pleaseRefreshThePageAndTryAgain, 'error')
                            break
                        case 503:
                            self.$store.commit('setMaintenanceMode', true)
                            break
                    }
                } else if (error.request) {
                    console.log(error.request)
                } else {
                    console.log('Error', error.message)
                }

                self.$store.commit('setLoadFilePercent', { text: self.language.anErrorHasOccurred })

                setTimeout(function() {
                    self.$store.commit('setLoadFileMode', false)
                }, 2000)

                return Promise.reject(error)
            })
        }
    },
    watch: {}
}
</script>

<style lang="scss" scoped>
.maintenance-mode-wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 100000000;
    background-color: #6993FF;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 2rem;
    text-align: center;
    padding: 15px;

    @media (max-width: 991px) {
        font-size: 1.4rem;
    }
    @media (max-width: 768px) {
        font-size: 1rem;
    }
}

.errors-items {
    list-style: none;
}

</style>

<style lang="scss">

body {
    pointer-events: auto!important;
}

@media print {
    table {
        width: 100%;
        table-layout: fixed;
    }

    th, td {
        word-break: break-word;
        font-size: 10pt;
    }
}

.disabled.day {
    color: #cecece !important;
}

.dt-buttons {
    float: right;

    .dt-button {
        border: 1px solid #e4e6ef;
        background-color: #fff;
        color: #000;
        padding: 5px 20px;
    }


}

input, select, textarea, .custom-select {
    outline: none !important;
}

.buttons-colvis {
    position: relative;
}

.dt-button-collection {
    margin: 0 !important;
    width: 400px;
    position: absolute;
    z-index: 1;
    right: 12.5px !important;
    left: unset !important;

    [role="menu"] {

        .buttons-columnVisibility.active {
            font-weight: bold;
            background-color: #e4e6ef;
        }


        button {
            width: 100%;
        }
    }
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
    opacity: 0;
}

.dataTables_wrapper .row {
    margin: 0;
}

.dataTables_wrapper .dataTable td, .dataTables_wrapper .dataTable th {
    font-size: 0.9rem;
}

.border-2px {
    border-width: 2px !important;
}

.scroll-btn {
    width: 40px;
    height: 40px;
    position: fixed;
    bottom: 30px;
    right: 30px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    z-index: 10;
    background: aliceblue;
    align-items: center;
    justify-content: center;
    opacity: 0;
}

.menu-text {
    text-wrap: nowrap;
}

.select2-selection {
    min-height: 39px !important;
}
</style>
